import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { DataStoreService } from '../../core/services/data-store/data-store.service';

// TODO MK-REF
@Component({
  selector: 'baf-single-view-custom',
  templateUrl: './single-view-custom.component.html',
  styleUrls: ['./single-view-custom.component.css']
})
export class SingleViewCustomComponent implements OnInit {
  private readonly startingTag = '<body>';
  private readonly endingTag = '</body>';
  isPopupVisible = false;
  resultView: string;

  constructor(storeService: DataStoreService) {
    storeService.getCustomSingleViewContent().subscribe(content => {
      this.isPopupVisible = this.isContentValid(content) && this.renderHtml(content);
    });
  }

  private isContentValid(content: string): boolean {
    return content && content.length > 0 ? true : false;
  }

  private renderHtml(content: string): boolean {
    const startingTagIndex = content.indexOf(this.startingTag);
    const endingTagIndex = content.indexOf(this.endingTag);
    if (startingTagIndex === -1 && endingTagIndex === -1) {
      this.resultView = content;
      return true;
    } else if (startingTagIndex >= 0 && endingTagIndex >= 0) {
      this.resultView = content.substring(
        startingTagIndex + this.startingTag.length,
        endingTagIndex
      );
      return true;
    }
    return false;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/single-view-custom/single-view-custom.component.ts